// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1gPuo","obliqueLineWrap":"membershipbadge_obliqueLineWrap__i8tK_","obliqueLine":"membershipbadge_obliqueLine__1s8jR"};